/**
 * Ce fichier permets d'afficher la positions en réel sous forme d'un cercle
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { useEffect } from 'react';

import { map } from './Map';

/*-------------------------------------------------------------------------------------------*/

export default function Add3DElement() {
  useEffect(() => {
    if (map.getSource('mapbox-dem') === undefined) {
      map.addSource('mapbox-dem', {
        type: 'raster-dem',
        url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
        tileSize: 512,
        maxzoom: 14
      });

      // add the DEM source as a terrain layer with exaggerated height
      map.setTerrain({ source: 'mapbox-dem', exaggeration: 1 });
    }

    // add a sky layer that will show when the map is highly pitched
    map.addLayer({
      id: 'sky',
      type: 'sky',
      paint: {
        'sky-type': 'atmosphere',
        'sky-atmosphere-sun': [0.0, 0.0],
        'sky-atmosphere-sun-intensity': 15
      }
    });

    if (map.getSource('composite')) {
      map.addLayer(
        {
          id: '3d-buildings',
          source: 'composite',
          'source-layer': 'building',
          type: 'fill-extrusion',
          minzoom: 14,
          paint: {
            'fill-extrusion-color': '#ddd',
            'fill-extrusion-height': ['number', ['get', 'height'], 5],
            'fill-extrusion-base': ['number', ['get', 'min_height'], 0],
            'fill-extrusion-opacity': 1
          }
        },
        'road-label'
      );
    }

    return () => {
      if (map.getLayer('sky')) {
        map.removeLayer('sky');
      }
      if (map.getLayer('building')) {
        map.removeLayer('building');
      }
      if (map.getLayer('3d-buildings')) {
        map.removeLayer('3d-buildings');
      }
    };
  }, []);

  return null;
}
